<template>
    <div>

        <PageHeader>
            {{ $t('webhooks') }}
        </PageHeader>

        <Card :loading="loading" overlay>

            <ErrorMessage :value="error" :dismissible="false" />

            <b-table-simple class="mb-0">
                <b-thead>
                    <b-tr>
                        <b-th class="border-top-0 width-500">{{ $t('yourPage') }}</b-th>
                        <b-th class="border-top-0 width-600">{{ $t('webhookUrl') }}</b-th>
                        <b-th class="border-top-0" />
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="space in spaces" :key="space.id">
                        <b-td>{{ space.name }}</b-td>
                        <b-td>
                            <FormValidator :attribute="$t('webhookUrl')" :validator="$v.form.webhookUrl[space.id]" v-slot="slotProps">
                                <div class="d-flex gap-3">
                                    <b-form-input
                                        v-model="form.webhookUrl[space.id]"
                                        :state="slotProps.state"
                                        placeholder="https://"
                                        class=""
                                        :disabled="requestSpace.getLoading(space.id)"
                                    />
                                </div>
                            </FormValidator>
                        </b-td>
                        <b-td>
                            <ButtonIcon :loading="requestSpace.getLoading(space.id)" hide-label-while-loading @click="saveWebhookUrl(space)">
                                {{ $t('save') }}
                            </ButtonIcon>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>

        </Card>

    </div>
</template>



<script>
    import { url } from 'vuelidate/lib/validators';
    import FormValidator from '@/components/common/FormValidator.vue';

    export default {
        name: 'Webhook',
        components: {
            FormValidator,
        },
        data() {
            return {
                requestSpaces: this.$req('space/spaces'),
                requestSpace: this.$req('space/space'),
                form: {
                    webhookUrl: {},
                },
            };
        },
        validations() {
            return {
                form: {
                    webhookUrl: this.spaces.reduce(
                        (acc, space) => ({
                            ...acc,
                            ...{
                                [space.id]: {
                                    url: () => (this.form.webhookUrl[space.id] ? url(this.form.webhookUrl[space.id]) : true),
                                },
                            },
                        }),
                        {}
                    ),
                },
            };
        },
        computed: {
            spaces() {
                return this.requestSpaces.getData()?.items || [];
            },
            error() {
                return this.requestSpaces.getError();
            },
            loading() {
                return this.requestSpaces.getLoading();
            },
        },
        watch: {
            spaces() {
                this.form.webhookUrl = this.spaces.reduce(
                    (acc, space) => ({
                        ...acc,
                        [space.id]: space.webhook,
                    }),
                    {}
                );
            },
        },
        methods: {
            fetchSpaces() {
                const userId = this.$store.getters['auth/getUser'].id;
                this.requestSpaces.get(userId, { statuses: '1,2' }).catch(() => {});
            },
            saveWebhookUrl(space) {
                const webhookUrl = this.form.webhookUrl[space.id] || '';
                this.$v.form.webhookUrl[space.id].$touch();
                if (!this.$v.form.webhookUrl[space.id].$invalid) {
                    this.requestSpace
                        .id(space.id)
                        .patch(space.id, { webhook: webhookUrl })
                        .then(() => this.$toastr.success(this.$t('dataSavedSuccessfully')))
                        .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
                }
            },
        },
        created() {
            this.fetchSpaces();
        },
    };
</script>
